module.exports = __webpack_public_path__ + "assets/img/portfolio-trecias-2x.ac11d40b.jpg";